module.exports = __webpack_public_path__ + "static/0019-289026e87cea10a8e2f8ab4fccc9632c.png";